import { render, staticRenderFns } from "./wallet-box3.vue?vue&type=template&id=7caef526&scoped=true&"
import script from "./wallet-box3.vue?vue&type=script&lang=js&"
export * from "./wallet-box3.vue?vue&type=script&lang=js&"
import style0 from "./wallet-box3.vue?vue&type=style&index=0&id=7caef526&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7caef526",
  null
  
)

export default component.exports